import React from "react";
import { Redirect } from "react-router-dom";
import {PageHeader, Row, Col, Typography, Divider,Button,Layout} from 'antd';
import {THEME} from '../../constant/theme';
import {t} from '../../constant/i18n';
import '../order/css/header.css'
const { Header, Footer, Sider, Content } = Layout;
const {Title, Paragraph, Text} = Typography;


class HeaderMember extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: null,
        }
    }

    goToOrder = () => {
        this.setState({redirect: '/order/new'})
    }
    goToSite = () => {
        window.location.href = THEME.urls.site;
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect}/>;
        }else {
            return (
                <PageHeader
                    className="site-page-header"
                    onBack={this.goToSite}
                    title={THEME.brand}
                    subTitle={t('header.backToSite')}
                    extra={[
                        <Button type="primary" size="large" onClick={this.goToOrder}>{t('ident.applyProject')}</Button>,
                        <img style={{width: "150px"}} src={THEME.logo}/>
                    ]}
                />
            )
        }
    }
}
export default HeaderMember;
